import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { Card, CardContent, Grid, Paper, WithStyles, withStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { styles } from "./CardsView.styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"; //for my orders
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined"; //for my subscriptions
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined"; //for download-center
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined"; //for personal data
import AssignmentIcon from '@material-ui/icons/Assignment';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as UserDetailsAction from "../../stores/user/UserDetailsAction";
import { useAuthContext } from "../../auth/AuthProvider";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import { PageBanner } from "../components/PageBanner/PageBanner";
import { isUsedCognito, isUsedOpenAM } from "../../utilities/userUtils";
import BuildIcon from "@material-ui/icons/Build";

export interface IAccountViewProps extends WithStyles<typeof styles> {
}

const MyAccountViewPure: React.FunctionComponent<IAccountViewProps> = ({classes}) => {
    const {t} = useTranslation();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;
    const dispatch = useDispatch();
    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);

    useEffect(() => {
        dispatch(UserDetailsAction.requestCurrentUser(userId));
    }, [userId, dispatch]);

    const userName = userDetails ? `${userDetails?.firstName} ${userDetails?.lastName}` : "";
    const userNickname = userDetails ? userDetails.username : "";

    interface ICard {
        icon: JSX.Element;
        title: string;
        path: string;
    }

    const cards: ICard[] = [
        {
            icon: <FileCopyOutlinedIcon />,
            title: t("general.myOrders"),
            path: "/my-account/my-orders"
        },
        {
            icon: <DateRangeOutlinedIcon />,
            title: t("manageAccount.mySubscriptions.mySubscriptions"),
            path: "/my-account/my-subscriptions",
        },
        {
            icon: <AssignmentIcon />,
            title: "My requests/reports",
            path: "/my-account/my-reports",
        },
        {
            icon: <PermIdentityOutlinedIcon />,
            title: t("manageAccount.personalData.personalData"),
            path: "/my-account/personal-data"
        },
        ...(isUsedCognito() ? [{
            icon: <LockOutlinedIcon />,
            title: t("manageAccount.changePassword.title"),
            path: "/my-account/change-password",
        }] : []),
        {
            icon: <GetAppOutlinedIcon />,
            title: t("manageAccount.downloadCentre.downloadCentre"),
            path: "/my-account/download-centre",
        },
        ...(isUsedOpenAM() ? [{
                icon: <BuildIcon />,
                title: "API token",
                path: "/my-account/api-token"
            }]
            : [])
    ];

    return (
        <>
            <PageBanner title="Manage Your Account" isPublic={false} />
            <CenteredContainer>
                <Paper elevation={0} className={classes.box}>
                    <div className={classes.title}>
                        <Typography variant="h3" className={classes.header}>
                            {t("manageAccount.myAccount")}
                        </Typography>
                        <Typography variant="subtitle1">{userName}</Typography>
                        <Typography variant="body2">{userNickname}</Typography>
                    </div>
                    <Grid container spacing={3} direction="row" alignItems="center">
                        {cards.map(card => (
                            <Grid item xs={12} sm={4} key={card.path as string}>
                                <NavLink to={card.path} style={{textDecoration: "none"}}>
                                    <Card variant="outlined" className={classes.card}>
                                        <CardContent className={classes.cardContent}>
                                            {card.icon}
                                            <span className={classes.cardTitle}>{card.title}</span>
                                        </CardContent>
                                    </Card>
                                </NavLink>
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            </CenteredContainer>
        </>
    );
};

export const MyAccountView = withStyles(styles)(MyAccountViewPure);
